<template>
  <svg id="order-details-barcode"/>
</template>

<script>
import jsBarcode from 'jsbarcode'

export default {
  name: 'Barcode',
  props: {
    text: [String, Number]
  },
  mounted () {
    jsBarcode('#order-details-barcode', this.text)
  },
  watch: {
    text (text) {
      jsBarcode('#order-details-barcode', this.text)
    }
  },
  computed: {
  }
}
</script>
